import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const postIncident = async (payload) => {
  try {
    const res = await postRequest({ url: "/incidents", payload: payload });
    return res;
  } catch (e) {
    throw e;
  }
};

export const putIncident = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "/incidents",
      payload: payload,
      query: { incident_id: id },
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const getIncidents = async (query) => {
  try {
    const res = await getRequest({
      url: "/incidents",
      query: query,
    });
    return res;
  } catch (e) {
    throw e;
  }
};
